import {
  Component,
  ViewChild,
  AfterViewInit } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TabsPage } from '../pages/tabs/tabs';
import { NotificationsPage } from '../pages/notifications/notifications';
import { SwipesPage } from '../pages/swipes/swipes';
import { TimesheetsPage } from '../pages/timesheets/timesheets';
import { UsersPage } from '../pages/users/users';
import { PlanningOverviewPage } from '../pages/planning-overview/planning-overview';
import { ReportsPage } from '../pages/reports/reports';
import { DailyTotalsOverviewPage } from '../pages/daily-totals-overview/daily-totals-overview';
import { WeekStatusPage } from '../pages/week-status/week-status';
import { Auth0Provider } from '../providers/auth0.provider';
import { TimeTrackerBaseApi } from '../providers/generic.service';
import { HomePage } from '../pages/home/home';
import { ProfilePage } from '../pages/profile/profile';
import { IUser } from '../../typings/timetracker/timetracker';
import { Observable } from 'rxjs/Observable';

import Auth0Cordova from '@auth0/cordova';

interface PageInterface {
  title: string;
  id: string;
  name: string;
  component: Component;
  tabComponent?: Component;
  index?: number;
  icon: string;
  role: 'administrator' | 'user';
}

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements AfterViewInit {

  // the root nav is a child of the root app component
  // @ViewChild(Nav) gets a reference to the app's root nav
  ///
  @ViewChild( Nav ) nav: Nav;

  rootPage:any = HomePage;

  selectedPageId: string;
  currentUser$: Observable<IUser>;

  // List of pages that can be navigated to from the left menu
  //
  public appPages: PageInterface[] = [
    { title: 'Activiteit', id: 'activity', name: 'TabsPage', component: TabsPage as Component, tabComponent: DailyTotalsOverviewPage as Component, icon: 'event', index: 0, role: 'user' },
    { title: 'Meldingen', id: 'notifications',  name: 'TabsPage', component: TabsPage as Component, tabComponent: NotificationsPage as Component, icon: 'notifications', index: 1, role: 'user' },
    { title: 'Profiel gegevens', id: 'profile',  name: 'TabsPage', component: TabsPage as Component, tabComponent: ProfilePage as Component, icon: 'information', index: 2, role: 'user' }
  ];

  public adminPages: PageInterface[] = [
    { title: 'Timesheets', id: 'TimesheetsPage', name: 'TimesheetsPage', component: TimesheetsPage as Component, icon: 'event_available', role: 'administrator' },
    { title: 'WeekStatus', id: 'WeekStatusPage', name: 'WeekStatusPage', component: WeekStatusPage as Component, icon: 'playlist_add_check', role: 'administrator' },
    { title: 'Planning', id: 'PlanningOverviewPage', name: 'PlanningOverviewPage', component: PlanningOverviewPage as Component, icon: 'schedule', role: 'administrator' },
    { title: 'Users', id: 'UsersPage', name: 'UsersPage', component: UsersPage as Component, icon: 'people', role: 'administrator' },
    { title: 'Export', id: 'ReportsPage', name: 'ReportsPage', component: ReportsPage as Component, icon: 'file_download', role: 'administrator' },
    { title: 'Swipes', id: 'SwipesPage', name: 'SwipesPage', component: SwipesPage as Component, icon: 'nfc', role: 'administrator' },
  ];


  // Open the selected page
  //
  openPage( page: PageInterface ) {

    console.log( '[TIME-TRACKER] Open page', page );
    let params = {};

    // the nav component was found using @ViewChild(Nav)
    // setRoot on the nav to remove previous pages and only have this page
    // we wouldn't want the back button to show in this scenario
    //
    if ( page.index) {
      params = { tabIndex: page.index };
    }

    // If we are already on tabs just change the selected tab
    // don't setRoot again, this maintains the history stack of the
    // tabs even if changing them from the menu
    //
    if (this.nav.getActiveChildNavs().length && page.index != undefined) {
      this.nav.getActiveChildNavs()[0].select(page.index);
    } else {
      // Set the root of the nav with params if it's a tab index
      //
      console.log(`[APP] Trying to open page ${page.name}` );
      this.nav.setRoot( page.name, params ).catch( (err: any) => {
        console.log(`Didn't set nav root: ${err}`);
      } );
    }

    this.selectedPageId = page.id;
  }

  // Go to the homepage
  //
  goHome() {

  }

  ngAfterViewInit() {

    let tabsSubscription;
    this.nav.viewWillEnter.subscribe( ( value ) => {

      if ( value.id === 'TabsPage' ) {

        tabsSubscription && tabsSubscription();
        console.log( this.nav.getActiveChildNavs()[ 0 ] );

        // tabsSubscription = this.nav.getActiveChildNav()[ 0 ].viewWillEnter.subscribe( ( data ) => {
        //   console.log( '====>', this.nav.getActiveChildNavs()[ 0 ].selectedIndex );
        // } );

      } else {
        this.selectedPageId = value.id;
      }

    } );
  }

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private $timetrackerAPI: TimeTrackerBaseApi,
    private $auth0Provider: Auth0Provider ) {

    platform.ready().then( () => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //
      statusBar.styleDefault();
      splashScreen.hide();

      this.rootPage = TabsPage;


      // Redirect back to app after authenticating
      (window as any).handleOpenURL = (url: string) => {
        Auth0Cordova.onRedirectUri(url);
      }

      this.$timetrackerAPI.doLoginRequired().subscribe( () => {
        this.nav.setRoot( 'LoginPage' );
      } );

      this.$auth0Provider.loggedInState.subscribe( ( loggedIn ) => {
        if ( loggedIn === false ) {

          // Show login
          //
          this.nav.setRoot( 'LoginPage' );
        }
      } );

      this.currentUser$ = this.$timetrackerAPI.selectCurrentUser();

      console.log( '[AUTH-GUARD] Going to check for a active session' );
      this.$timetrackerAPI.isLoggedIn().then( ( payload ) => {
        console.log( '[AUTH-GUARD] Check if user is logged in', payload );
      } ).catch( ( error ) => {
        console.error( '[AUTH-GUARD] Cannot determin if the user is logged-in', error );
      } );

      this.$auth0Provider.profile()
      .then( ( profile ) => {

        // Set root page
        //
        if ( !profile ) {
          this.nav.setRoot( 'LoginPage' );
        }
        else {

        }

      } )
      .catch( ( e ) => {
        console.error( '[AUTH-GUARD] Problem while testing for profile', e );
      } );
    } );
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts